import React, {FC, useCallback} from "react";
import {ActionButton, IButtonProps, IContextualMenuItem, PrimaryButton, Spinner,} from "@fluentui/react";

interface ILoadingButtonProps extends IButtonProps {
    loading?: boolean;
    loadingOnClick?: number;
    actionButton?: boolean;
    menuItems?: Array<IContextualMenuItem>;
}

export const LoadingButton: FC<ILoadingButtonProps> = (props) => {
    const [loading, setLoading] = React.useState(false);

    const onClick = useCallback(
        (ev: any, data?: any) => {
            if (props.onClick) {
                if (props.loadingOnClick) {
                    setLoading(true);
                    setTimeout(() => {
                        setLoading(false);
                    }, props.loadingOnClick);
                }
                props.onClick(ev);
            }
        },
        [props, props.menuItems],
    );

    if (props.actionButton) {
        return (
            <ActionButton
                {...props}
                split={!!props.menuItems}
                menuProps={
                    props.menuItems
                        ? {
                            items: props.menuItems,
                        }
                        : undefined
                }
                disabled={loading || props.loading || props.disabled}
                text={props.text}
                onClick={onClick}
                onRenderIcon={
                    loading || props.loading ? () => <Spinner/> : props.onRenderIcon
                }
            />
        );
    }
    return (
        <PrimaryButton
            split={!!props.menuItems}
            menuProps={
                props.menuItems
                    ? {
                        items: props.menuItems,
                    }
                    : undefined
            }
            {...props}
            disabled={loading || props.loading || props.disabled}
            text={props.text}
            onClick={onClick}
            onRenderIcon={
                loading || props.loading ? () => <Spinner/> : props.onRenderIcon
            }
        />
    );
};
